<template>
	<div class="componentbox">
		<div class="title-box">
			<span>{{titleText}}</span>
		</div>
		<div class="container-box">
			<div v-if="type === 1" class='flex-column'>
				<div class="row-box">
					<div class="span-box">默认搜索值：</div>
					<el-input v-model="wordsearch" @change='reloadAllData' maxlength="20" placeholder="请输入默认搜索值" size="mini"></el-input>
				</div>
				<div class="row-box">
					<div class="span-box">搜索热词：</div>
					<span style="color:#999999">最多配置5个搜索热词</span>
				</div>
				<vuedraggable v-model="dataList" @end='reloadAllData'>
					<div class="word-row" v-for="(item, index) in dataList" :key="index">
						<img src="~/images/icon/yidongshu.png" alt="" style="margin-right:5px"/>
						<el-input v-model="item.wordsearch" @change='reloadAllData' placeholder="请输入搜索热词" maxlength="20" size="mini"></el-input>
						<i class="el-icon-remove" @click="deleteClick(index)"></i>
					</div>
				</vuedraggable>
				<div v-if='dataList.length < 5' @click="addWordsearch" class="btn-box">+ 添加搜索热词（{{dataList.length}}/5）</div>
			</div>
			<div v-if="type === 2" class='flex-column'>
				<div class="row-box">
					<div class="span-box" style="width: 100px;">公告使用设置：</div>
					<el-radio v-model="useway" @change="reloadAllData" :label="0">使用原店铺设置中的公告</el-radio>
				</div>
				<div class="row-box">
					<div class="span-box" style="width: 100px;"></div>
					<el-radio v-model="useway" @change="reloadAllData" :label="1">使用该页面公告</el-radio>
				</div>
				<div class="row-box" v-if="useway === 1">
					<div class="span-box" style="width: 100px;">应用该页面公告：</div>
					<el-radio v-model="disabledflag" @change="reloadAllData" :label="1">启用</el-radio>
					<el-radio v-model="disabledflag" @change="reloadAllData" :label="0">禁用</el-radio>
				</div>
				<div class="row-box" v-if="useway === 1">
					<div class="span-box">公告内容：</div>
				</div>
				<div v-if="useway === 1">
					<el-input
						:disabled='disabledflag === 0'
						@change="reloadAllData"
						type="textarea"
						placeholder="请输入内容"
						v-model="detail"
						:rows="8"
						maxlength="200"
						show-word-limit
					>
					</el-input>
				</div>
			</div>
			<div v-if="type === 3" class='flex-column'>
				<div class="row-box">
					<div class="span-box">选择模版：</div>
					<span v-if="template === 1">每行一个</span>
					<span v-if="template === 2">轮播图</span>
				</div>
				<div class="row-box">
					<img v-if="template === 2" @click="templateCLick(1)" src="~/images/icon/advert-1-1.png" />
					<img v-if="template === 1" src="~/images/icon/advert-1-2.png" />
					<img v-if="template === 2" src="~/images/icon/advert-2-2.png" />
					<img v-if="template === 1" @click="templateCLick(2)" src="~/images/icon/advert-2-1.png" />
				</div>
				<div class="row-box">
					<div class="span-box" style="width: 100px;">图片链接设置：</div>
				</div>
				<div style="color:#999999;text-align:left">
					图片尺寸建议750*200像素，图片最大1MB，图片格式png、jpg、jpeg，最多添加5个，鼠标拖拽调整广告顺序。
				</div>
				<vuedraggable v-model="dataList" @end='reloadAllData'>
					<div class="advert-row" v-for="(item, index) in dataList" :key="index">
						<ImgUplaod
							:imgSrc.sync="item.imgurl"
							:imgId.sync="item.id"
							:seqnum='index'
							@imgChange='imgChange'
						></ImgUplaod>
						链接：
						<div v-if="item.targetid !== ''" class="choose-item">
							<div class="choose-item-text">{{item.type === 1 ? '商品' : item.type === 2 ? '商品大类' : '商品小类'}}|{{item.targetname}}</div>
							<i class="el-icon-error del-pro-btn" @click="delProClick(index)"></i>
						</div>
						<el-dropdown v-if="item.targetid === ''" @command="handleCommand" trigger="click">
							<span class="el-dropdown-link">
								选择跳转到的页面<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="{index: index, value: 1}">商品详情</el-dropdown-item>
								<el-dropdown-item :command="{index: index, value: 2}">商品大类</el-dropdown-item>
								<el-dropdown-item v-if="showSmall" :command="{index: index, value: 3}">商品小类</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<el-dropdown v-if="item.targetid !== ''" style="margin-left: 10px;" @command="handleCommand1" trigger="click">
							<span class="el-dropdown-link">
								修改<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="{index: index, value: 1}">商品详情</el-dropdown-item>
								<el-dropdown-item :command="{index: index, value: 2}">商品大类</el-dropdown-item>
								<el-dropdown-item v-if="showSmall" :command="{index: index, value: 3}">商品小类</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<i class="el-icon-remove" @click="deleteClick(index)"></i>
					</div>
				</vuedraggable>
				<div v-if='dataList.length < 5' @click="addAdvert" class="btn-box">+ 添加图片链接（{{dataList.length}}/5）</div>
			</div>
			<div v-if="type === 4" class='flex-column'>
				<div class="row-box">
					<div class="span-box">选择模版：</div>
					<span v-if="template === 1">每行4个</span>
					<span v-if="template === 2">每行5个</span>
				</div>
				<div class="row-box">
					<img v-if="template === 2" @click="templateCLick(1)" src="~/images/icon/navigation-1-1.png" />
					<img v-if="template === 1" src="~/images/icon/navigation-1-2.png" />
					<img v-if="template === 2" src="~/images/icon/navigation-2-2.png" />
					<img v-if="template === 1" @click="templateCLick(2)" src="~/images/icon/navigation-2-1.png" />
				</div>
				<div class="row-box">
					<div class="span-box">模式：</div>
					<el-radio v-model="pattern" @change="reloadAllData" :label="1">固定</el-radio>
					<el-radio v-model="pattern" @change="reloadAllData" :label="2">单行滑动</el-radio>
					<el-radio v-model="pattern" @change="reloadAllData" :label="3">双行滑动</el-radio>
				</div>
				<div class="row-box">
					<div class="span-box" style="width: 100px;">图片链接设置：</div>
				</div>
				<div style="color:#999999;text-align:left">
					图片尺寸建议100*100像素，图片最大1MB，图片格式png、jpg、jpeg，最多添加20个，
					鼠标拖拽调整顺序。
				</div>
				<vuedraggable v-model="dataList" @end='reloadAllData'>
					<div class="advert-row" v-for="(item, index) in dataList" :key="index">
						<ImgUplaod
							:imgSrc.sync="item.imgurl"
							:imgId.sync="item.id"
							:seqnum='index'
							@imgChange='imgChange'
						></ImgUplaod>
						<div>
							<div class="nav-row">
								<div class="title">
									标题：
								</div>
								<el-input
									size='mini'
									maxlength="10"
									@change="reloadAllData"
									placeholder="请输入标题"
									v-model="item.name"
								>
								</el-input>
							</div>
							<div class="nav-row">
								<div class="title">
									链接：
								</div>
								<div v-if="item.targetid !== ''" class="choose-item">
									<div class="choose-item-text">{{item.type === 1 ? '商品' : item.type === 2 ? '商品大类' : '商品小类'}}|{{item.targetname}}</div>
									<i class="el-icon-error del-pro-btn" @click="delProClick(index)"></i>
								</div>
								<el-dropdown v-if="item.targetid === ''" @command="handleCommand" trigger="click">
									<span class="el-dropdown-link">
										选择跳转到的页面<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item :command="{index: index, value: 1}">商品详情</el-dropdown-item>
										<el-dropdown-item :command="{index: index, value: 2}">商品大类</el-dropdown-item>
										<el-dropdown-item v-if="showSmall" :command="{index: index, value: 3}">商品小类</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<el-dropdown v-if="item.targetid !== ''" style="margin-left: 10px;" @command="handleCommand1" trigger="click">
									<span class="el-dropdown-link">
										修改<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item :command="{index: index, value: 1}">商品详情</el-dropdown-item>
										<el-dropdown-item :command="{index: index, value: 2}">商品大类</el-dropdown-item>
										<el-dropdown-item v-if="showSmall" :command="{index: index, value: 3}">商品小类</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
						<i class="el-icon-remove" @click="deleteClick(index)"></i>
					</div>
				</vuedraggable>
				<div v-if='dataList.length < 20' @click="addNav" class="btn-box">+ 添加图片链接（{{dataList.length}}/20）</div>
			</div>
			<div v-if="type === 5" class='flex-column'>
				<div class="row-box">
					<div class="span-box">标题名称：</div>
					<el-input v-model="name" @change='reloadAllData' maxlength="20" placeholder="请输入标题名称" size="mini"></el-input>
				</div>
				<div class="row-box">
					<div class="span-box">选择模版：</div>
					<span v-if="template === 1">一行两个</span>
					<span v-if="template === 2">横向滑动</span>
					<span v-if="template === 3">列表平铺</span>
				</div>
				<div class="row-box">
					<img class="progroup-icon" v-if="template === 1" src="~/images/icon/progroup-1-2.png" />
					<img class="progroup-icon" v-else @click="templateCLick(1)" src="~/images/icon/progroup-1-1.png" />
					<img class="progroup-icon" v-if="template === 2" src="~/images/icon/progroup-2-2.png" />
					<img class="progroup-icon" v-else @click="templateCLick(2)" src="~/images/icon/progroup-2-1.png" />
					<img class="progroup-icon" v-if="template === 3" src="~/images/icon/progroup-3-2.png" />
					<img class="progroup-icon" v-else @click="templateCLick(3)" src="~/images/icon/progroup-3-1.png" />
				</div>
				<div class="row-box">
					<div class="span-box">添加商品：</div>
				</div>
				<vuedraggable v-model="dataList" @end='reloadAllData'>
					<div class="pro-row" v-for="(item, index) in dataList" :key="index">
						<img src="~/images/icon/yidongshu.png" alt="" style="margin-right:5px"/>
						<w-image class="pro-img" v-if="item.imgurl !== ''" :src="item.imgurl"></w-image>
						<img class="pro-img" v-if="item.imgurl === ''" src="~/images/icon/pro-no-img.png" />
						{{item.productname}}
						<i class="el-icon-remove" @click="deleteClick(index)"></i>
					</div>
				</vuedraggable>
				<div v-if='dataList.length < 10' @click="addpro" class="btn-box">+ 添加图片链接（{{dataList.length}}/10）</div>
			</div>
			<div v-if="type === 6" class='flex-column'>
				<div class="row-box">
					<div class="span-box" style="width:100px;">标题显示设置：</div>
					<el-radio v-model="shownameflag" @change="reloadAllData" :label="1">显示</el-radio>
					<el-radio v-model="shownameflag" @change="reloadAllData" :label="0">不显示</el-radio>
				</div>
				<div class="row-box">
					<div class="span-box">标题名称：</div>
					<el-input v-model="name" maxlength="20" @change='reloadAllData' placeholder="请输入标题名称" size="mini"></el-input>
				</div>
				<div class="row-box">
					<div class="span-box">选择模版：</div>
					<span v-if="template === 1">一行两个</span>
					<span v-if="template === 2">一行三个</span>
					<span v-if="template === 3">一行一个一行两个</span>
					<span v-if="template === 4">一行一个一行三个</span>
					<span v-if="template === 5">一行l两个一行四个</span>
					<span v-if="template === 6">左一右二</span>
				</div>
				<div class="row-box">
					<img v-if="template !== 1" @click="templateCLick(1)" src="~/images/icon/recommendation-1-1.png" />
					<img v-if="template === 1" src="~/images/icon/recommendation-1-2.png" />
					<img v-if="template !== 2" @click="templateCLick(2)" src="~/images/icon/recommendation-2-1.png" />
					<img v-if="template === 2" src="~/images/icon/recommendation-2-2.png" />
					<img v-if="template !== 3" @click="templateCLick(3)" src="~/images/icon/recommendation-3-1.png" />
					<img v-if="template === 3" src="~/images/icon/recommendation-3-2.png" />
					<img v-if="template !== 4" @click="templateCLick(4)" src="~/images/icon/recommendation-4-1.png" />
					<img v-if="template === 4" src="~/images/icon/recommendation-4-2.png" />
					<img v-if="template !== 5" @click="templateCLick(5)" src="~/images/icon/recommendation-5-1.png" />
					<img v-if="template === 5" src="~/images/icon/recommendation-5-2.png" />
					<img v-if="template !== 6" @click="templateCLick(6)" src="~/images/icon/recommendation-6-1.png" />
					<img v-if="template === 6" src="~/images/icon/recommendation-6-2.png" />
				</div>
				<div class="row-box">
					<div class="span-box">布局：</div>
				</div>
				<div v-if="template === 1" class="recommendation-1-box">
					<div class="item-box" @click="itemBoxClick(0)" :class="chooseIndex === 0 ? 'is-select-box' : ''">
						宽度340像素
					</div>
					<div class="item-box" @click="itemBoxClick(1)" :class="chooseIndex === 1 ? 'is-select-box' : ''">
						宽度340像素
					</div>
				</div>
				<div v-if="template === 2" class="recommendation-2-box">
					<div class="item-box" @click="itemBoxClick(0)" :class="chooseIndex === 0 ? 'is-select-box' : ''">
						<div>222*222像素</div>
						<div>或同等比例</div>
					</div>
					<div class="item-box" @click="itemBoxClick(1)" :class="chooseIndex === 1 ? 'is-select-box' : ''">
						<div>222*222像素</div>
						<div>或同等比例</div>
					</div>
					<div class="item-box" @click="itemBoxClick(2)" :class="chooseIndex === 2 ? 'is-select-box' : ''">
						<div>222*222像素</div>
						<div>或同等比例</div>
					</div>
				</div>
				<div v-if="template === 3" class="recommendation-3-box">
					<div class="item-box" @click="itemBoxClick(0)" :class="chooseIndex === 0 ? 'is-select-box' : ''">
						<div>696*340像素</div>
						<div>或同等比例</div>
					</div>
					<div style="flex:1;display:flex;flex-direction: row;">
						<div class="item-box" @click="itemBoxClick(1)" :class="chooseIndex === 1 ? 'is-select-box' : ''">
							<div>340*340像素</div>
							<div>或同等比例</div>
						</div>
						<div class="item-box" @click="itemBoxClick(2)" :class="chooseIndex === 2 ? 'is-select-box' : ''">
							<div>340*340像素</div>
							<div>或同等比例</div>
						</div>
					</div>
				</div>
				<div v-if="template === 4" class="recommendation-4-box">
					<div class="item-box" @click="itemBoxClick(0)" :class="chooseIndex === 0 ? 'is-select-box' : ''">
						<div>696*222像素</div>
						<div>或同等比例</div>
					</div>
					<div style="flex:1;display:flex;flex-direction: row;">
						<div class="item-box" @click="itemBoxClick(1)" :class="chooseIndex === 1 ? 'is-select-box' : ''">
							<div>222*222像素</div>
							<div>或同等比例</div>
						</div>
						<div class="item-box" @click="itemBoxClick(2)" :class="chooseIndex === 2 ? 'is-select-box' : ''">
							<div>222*222像素</div>
							<div>或同等比例</div>
						</div>
						<div class="item-box" @click="itemBoxClick(3)" :class="chooseIndex === 3 ? 'is-select-box' : ''">
							<div>222*222像素</div>
							<div>或同等比例</div>
						</div>
					</div>
				</div>
				<div v-if="template === 5" class="recommendation-5-box">
					<div style="display:flex;flex-direction: row;height:200px;">
						<div class="item-box" @click="itemBoxClick(0)" :class="chooseIndex === 0 ? 'is-select-box' : ''">
							<div>340*340像素</div>
							<div>或同等比例</div>
						</div>
						<div class="item-box" @click="itemBoxClick(1)" :class="chooseIndex === 1 ? 'is-select-box' : ''">
							<div>340*340像素</div>
							<div>或同等比例</div>
						</div>
					</div>
					<div style="flex:1;display:flex;flex-direction: row;">
						<div class="item-box" @click="itemBoxClick(2)" :class="chooseIndex === 2 ? 'is-select-box' : ''">
							<div>222*222像素</div>
							<div>或同等比例</div>
						</div>
						<div class="item-box" @click="itemBoxClick(3)" :class="chooseIndex === 3 ? 'is-select-box' : ''">
							<div>222*222像素</div>
							<div>或同等比例</div>
						</div>
						<div class="item-box" @click="itemBoxClick(4)" :class="chooseIndex === 4 ? 'is-select-box' : ''">
							<div>222*222像素</div>
							<div>或同等比例</div>
						</div>
						<div class="item-box" @click="itemBoxClick(5)" :class="chooseIndex === 5 ? 'is-select-box' : ''">
							<div>222*222像素</div>
							<div>或同等比例</div>
						</div>
					</div>
				</div>
				<div v-if="template === 6" class="recommendation-6-box">
					<div class="item-box" @click="itemBoxClick(0)" :class="chooseIndex === 0 ? 'is-select-box' : ''">
						<div>700*340像素</div>
						<div>或同等比例</div>
					</div>
					<div style="flex:1;display:flex;flex-direction: column;">
						<div class="item-box" @click="itemBoxClick(1)" :class="chooseIndex === 1 ? 'is-select-box' : ''">
							<div>340*340像素</div>
							<div>或同等比例</div>
						</div>
						<div class="item-box" @click="itemBoxClick(2)" :class="chooseIndex === 2 ? 'is-select-box' : ''">
							<div>340*340像素</div>
							<div>或同等比例</div>
						</div>
					</div>
				</div>

				<div class="advert-row">
						<ImgUplaod
							v-if="chooseData.imgurl !== null"
							:imgSrc.sync="chooseData.imgurl"
							:imgId.sync="chooseData.id"
							@imgChange='imgChange'
						></ImgUplaod>
						<div>
							<div class="nav-row">
								<div class="title">
									链接：
								</div>
								<div v-if="chooseData.targetid !== ''" class="choose-item">
									<div class="choose-item-text">{{chooseData.type === 1 ? '商品' : chooseData.type === 2 ? '商品大类' : '商品小类'}}|{{chooseData.targetname}}</div>
									<i class="el-icon-error del-pro-btn" @click="delProClick1()"></i>
								</div>
								<!-- <div v-if="chooseData.targetid !== ''" class="choose-item">{{chooseData.type === 1 ? '商品' : chooseData.type === 2 ? '商品大类' : '商品小类'}}|{{chooseData.targetname}}</div> -->
								<el-dropdown v-if="chooseData.targetid === ''" @command="recommendationCommand" trigger="click">
									<span class="el-dropdown-link">
										选择跳转到的页面<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item :command="{ value: 1}">商品详情</el-dropdown-item>
										<el-dropdown-item :command="{ value: 2}">商品大类</el-dropdown-item>
										<el-dropdown-item v-if="showSmall" :command="{ value: 3}">商品小类</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<el-dropdown v-if="chooseData.targetid !== ''" style="margin-left: 10px;" @command="recommendationCommand1" trigger="click">
									<span class="el-dropdown-link">
										修改<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item :command="{ value: 1}">商品详情</el-dropdown-item>
										<el-dropdown-item :command="{ value: 2}">商品大类</el-dropdown-item>
										<el-dropdown-item v-if="showSmall" :command="{ value: 3}">商品小类</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
					</div>
			</div>
			<div v-if="type === 7" class='flex-column'>
				<div style="color: #999999; font-size: 12px;text-align: left;" >视频广告最大限制20M，视规时长≤20s，支持文件类型：mp4，推荐视频比例16：9 （视频可点击预览播放） </div>
				<VideoUpload
					@reloadVideo="reloadVideo"
					:videoSrc.sync="videoNewUrl"
					ref="videoUpload"
				/>
			</div>
			<div v-if="type === 8" class='flex-column'>
				<div class="row-box">
					<div class="span-box">标题名称：</div>
					<el-input v-model="pageTitle" maxlength="8" @change='reloadAllData' placeholder="请输入标题名称" size="mini"></el-input>
				</div>
			</div>
		</div>
		<el-dialog
			:title="dialogTitle"
			class="dialog-title"
			:visible.sync="dialogModel"
			:close-on-click-modal="false"
			width="900px">
			<selectLink v-if="dialogModel" :linkType='linkType' :showSmall='showSmall' :selectId='selectId' @cancelClick='cancelClick' @reloadData='reloadData'></selectLink>
		</el-dialog>
		<el-dialog
			title="选择商品"
			class="dialog-title"
			:visible.sync="addProDialog"
			:close-on-click-modal="false"
			width="900px">
			<addPro v-if="addProDialog" :showSmall='showSmall' :selectPro='selectPro' @cancelClick='cancelClick' @reloadData='reloadProData'></addPro>
		</el-dialog>
	</div>
</template>

<script>
import VideoUpload from '@/components/customPage/VideoUpload.vue'
import ImgUplaod from '@/components/customPage/ImgUpload.vue'
import selectLink from '@/components/customPage/selectLink.vue'
import addPro from '@/components/customPage/addPro.vue'
import vuedraggable from 'vuedraggable'
export default {
	name: 'componentbox',
	components: {
		ImgUplaod, selectLink, vuedraggable, addPro, VideoUpload
	},
	data () {
		return {
			videoNewUrl: '',
			chooseData: null,
			chooseIndex: null,
			shownameflag: null,
			pattern: null,
			name: '',
			selectIndex: null,
			selectId: '',
			showSmall: false,
			addProDialog: false,
			dialogTitle: '',
			template: null,
			detail: '',
			useway: null,
			disabledflag: null,
			dialogModel: false,
			dataList: [],
			wordsearch: '',
			type: null,
			linkType: null,
			titleText: '',
			pageTitle: ''
		}
	},
	created () {
		this.checkSmall()
	},
	methods: {
		reloadVideo (data) {
			this.videoNewUrl = data
			this.reloadAllData()
		},
		cancelClick () {
			this.addProDialog = false
			this.dialogModel = false
		},
		delProClick1 () {
			this.chooseData.targetid = ''
			this.chooseData.targetname = ''
			this.chooseData.type = 0
			let index = this.chooseIndex
			let list = this.$fxUtils.deepClone(this.dataList)
			list[index].targetid = ''
			list[index].targetname = ''
			list[index].type = 0
			this.dataList = list
			this.reloadAllData()
		},
		delProClick (index) {
			let list = this.$fxUtils.deepClone(this.dataList)
			list[index].targetid = ''
			list[index].targetname = ''
			list[index].type = 0
			this.dataList = list
			this.reloadAllData()
		},
		itemBoxClick (index) {
			this.chooseData = this.dataList[index]
			this.chooseIndex = index
		},
		recommendationInitData () {
			let template = this.template
			let list = []
			let oldList = this.dataList
			if (template === 1) {
				list = oldList.slice(0, 2)
			}
			if (template === 2 || template === 3 || template === 6) {
				if (oldList.length > 3) {
					list = oldList.slice(0, 3)
				} else {
					let num = 3 - oldList.length
					list = oldList
					for (let i = 0; i < num; i++) {
						let row = {
							name: '',
							imgurl: '',
							targetid: '',
							targetname: '',
							type: 0
						}
						list.push(row)
					}
				}
			}
			if (template === 4) {
				if (oldList.length > 4) {
					list = oldList.slice(0, 4)
				} else {
					let num = 4 - oldList.length
					list = oldList
					for (let i = 0; i < num; i++) {
						let row = {
							name: '',
							imgurl: '',
							targetid: '',
							targetname: '',
							type: 0
						}
						list.push(row)
					}
				}
			}
			if (template === 5) {
				let num = 6 - oldList.length
				list = oldList
				for (let i = 0; i < num; i++) {
					let row = {
						name: '',
						imgurl: '',
						targetid: '',
						targetname: '',
						type: 0
					}
					list.push(row)
				}
			}
			return list
		},
		addpro () {
			this.selectPro = JSON.parse(JSON.stringify(this.dataList))
			this.addProDialog = true
		},
		reloadAllData () {
			this.$emit('reloadData')
		},
		getData () {
			let data = {}
			if (this.type === 1) {
				data.dataList = this.dataList
				data.wordsearch = this.wordsearch
			}
			if (this.type === 2) {
				data.detail = this.detail
				data.disabledflag = this.disabledflag
				data.useway = this.useway
			}
			if (this.type === 3) {
				data.template = this.template
				data.dataList = this.dataList
			}
			if (this.type === 4) {
				data.pattern = this.pattern
				data.template = this.template
				data.dataList = this.dataList
				if (this.pattern === 1) {
					data.showArr = this.dataList
				} else {
					data.showArr = this.initShowArr()
				}
			}
			if (this.type === 5) {
				data.name = this.name
				data.template = this.template
				data.dataList = this.dataList
			}
			if (this.type === 6) {
				data.name = this.name
				data.template = this.template
				data.shownameflag = this.shownameflag
				data.dataList = this.dataList
			}
			if (this.type === 7) {
				data.dataList = [{
					imgurl: this.videoNewUrl
				}]
			}
			if (this.type === 8) {
				data.name = this.pageTitle
			}
			return data
		},
		initShowArr () {
			let num = this.template === 1 ? 4 : 5
			let arr = []
			if (this.pattern === 2) {
				for (let i = 0; i < this.dataList.length; i = i + num) {
					arr.push(this.dataList.slice(i, i + num))
				}
			} else {
				let num1 = 2 * num
				for (let i = 0; i < this.dataList.length; i = i + num1) {
					arr.push(this.dataList.slice(i, i + num1))
				}
			}
			return arr
		},
		reloadData (data) {
			if (this.type === 6) {
				if (this.linkType === 1) {
					this.dataList[this.chooseIndex].targetid = data.productid
					this.dataList[this.chooseIndex].targetname = data.productname
				} else {
					this.dataList[this.chooseIndex].targetid = data.categoryid
					this.dataList[this.chooseIndex].targetname = data.categoryName
				}
			} else {
				if (this.linkType === 1) {
					this.dataList[this.selectIndex].targetid = data.productid
					this.dataList[this.selectIndex].targetname = data.productname
				} else {
					this.dataList[this.selectIndex].targetid = data.categoryid
					this.dataList[this.selectIndex].targetname = data.categoryName
				}
			}
			this.dialogModel = false
		},
		reloadProData (data) {
			this.dataList = data
			this.reloadAllData()
			this.addProDialog = false
		},
		checkSmall () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.showSmall = res.bigcategoryview === 1
			})
		},
		handleCommand1 (data) {
			this.selectIndex = data.index
			this.selectId = ''
			this.linkType = data.value
			switch (data.value) {
			case 1:
				this.dialogTitle = '选择商品'
				break
			case 2:
				this.dialogTitle = '选择商品大类'
				break
			case 3:
				this.dialogTitle = '选择商品小类'
				break
			}
			this.dialogModel = true
			this.reloadAllData()
		},
		recommendationCommand1 (data) {
			this.selectId = ''
			this.linkType = data.value
			switch (data.value) {
			case 1:
				this.dialogTitle = '选择商品'
				break
			case 2:
				this.dialogTitle = '选择商品大类'
				break
			case 3:
				this.dialogTitle = '选择商品小类'
				break
			}
			this.dialogModel = true
			this.reloadAllData()
		},
		recommendationCommand (data) {
			this.dataList[this.chooseIndex].type = data.value
			this.selectId = this.dataList[this.chooseIndex].targetid
			this.linkType = data.value
			switch (data.value) {
			case 1:
				this.dialogTitle = '选择商品'
				break
			case 2:
				this.dialogTitle = '选择商品大类'
				break
			case 3:
				this.dialogTitle = '选择商品小类'
				break
			}
			this.dialogModel = true
			this.reloadAllData()
		},
		handleCommand (data) {
			this.selectIndex = data.index
			this.dataList[data.index].type = data.value
			this.selectId = this.dataList[data.index].targetid
			this.linkType = data.value
			switch (data.value) {
			case 1:
				this.dialogTitle = '选择商品'
				break
			case 2:
				this.dialogTitle = '选择商品大类'
				break
			case 3:
				this.dialogTitle = '选择商品小类'
				break
			}
			this.dialogModel = true
			this.reloadAllData()
		},
		imgChange () {
			this.reloadAllData()
		},
		templateCLick (data) {
			this.template = data
			if (this.type === 6) {
				this.chooseIndex = 0
				this.dataList = this.recommendationInitData()
				this.chooseData = this.dataList[0]
			}
			this.reloadAllData()
		},
		deleteClick (index) {
			this.dataList.splice(index, 1)
			this.reloadAllData()
		},
		addNav () {
			let row = {
				name: '',
				imgurl: '',
				type: 0,
				targetname: '',
				targetid: ''
			}
			this.dataList.push(row)
			this.reloadAllData()
		},
		addAdvert () {
			let row = {
				imgurl: '',
				type: 0,
				targetname: '',
				targetid: ''
			}
			this.dataList.push(row)
			this.reloadAllData()
		},
		addWordsearch () {
			let row = {
				wordsearch: '',
				type: 1
			}
			this.dataList.push(row)
			this.reloadAllData()
		},
		initData (data) {
			this.dataList = []
			this.type = data.type
			switch (this.type) {
			case 1 :
				this.titleText = '商品搜索'
				this.dataList = data.data.dataList
				this.wordsearch = data.data.wordsearch
				break
			case 2 :
				this.titleText = '店铺公告'
				this.useway = data.data.useway
				this.disabledflag = data.data.disabledflag
				this.detail = data.data.detail
				break
			case 3 :
				this.titleText = '图片广告'
				this.template = data.data.template
				this.dataList = data.data.dataList
				break
			case 4 :
				this.titleText = '图文导航'
				this.template = data.data.template
				this.pattern = data.data.pattern
				this.dataList = data.data.dataList
				break
			case 5 :
				this.titleText = '商品组'
				this.name = data.data.name
				this.template = data.data.template
				this.dataList = data.data.dataList
				break
			case 6 :
				this.titleText = '精品推荐'
				this.template = data.data.template
				this.dataList = data.data.dataList
				this.name = data.data.name
				this.shownameflag = data.data.shownameflag
				this.chooseData = this.dataList[0]
				this.chooseIndex = 0
				break
			case 7 :
				this.titleText = '视频广告'
				this.videoNewUrl = data.data.dataList[0].imgurl
				break
			case 8 :
				this.titleText = '页面标题'
				this.pageTitle = data.data.name
				break
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.componentbox{
	font-size: 12px;
	color: #333333;
	font-family: Microsoft YaHei;
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
	box-sizing: border-box;
	align-items: flex-start;
	.del-pro-btn{
		margin-left:  5px;
		font-size: 16px;
		color:#C0C7D6
	}
	.progroup-icon{
		width: 61px;
		height: 36px
	}
	.title-box{
		padding: 0 20px;
		margin-top: 10px;
		height: 40px;
		line-height: 40px;
		font-weight: bold;
		font-size: 18px;
		color: #333333;
	}
	.container-box{
		flex: 1;
		height: 100%;
		width: 100%;
		overflow-y: auto;
		padding: 0 20px;
		box-sizing: border-box
	}
	.flex-column{
		display: flex;
		flex-direction: column
	}
	.btn-box{
		width: 100%;
		height: 36px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #FFFFFF;
		border: 1px solid var(--fx-primary-color);
		border-radius: 4px;
		color: var(--fx-primary-color);
		margin-top: 20px;
	}
	.row-box{
		height: 50px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start
		.span-box{
			width: 80px;
			text-align: left;
			min-width: 80px;
		}
	}
	.word-row{
		margin-top:24px;
		padding: 0 15px 0 5px;
		height: 60px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		background: #FFFFFF;
		box-shadow: -3px 1px 8px 0px rgba(128, 128, 128, 0.14);
		border-radius: 2px;
		position: relative
		.el-icon-remove	{
			cursor: pointer
			position: absolute;
			right: -5px;
			bottom: 50px
			font-size: 18px;
			font-weight: bold;
			color: var(--fx-primary-color);
		}
	}
	.nav-row{
		display: flex;
		flex-direction: row;
		align-items: center;
		height: 40px;
		justify-content: flex-start
		.title{
			width:40px;
			flex-shrink: 0
		}
	}
	.choose-item{
		padding: 5px;
		background: var(--fx-primary-tint-bg);
		border: 1px solid var(--fx-primary-color);
		border-radius: 4px;
		color: var(--fx-primary-color)
		display:flex;
		align-items: center;
		justify-content: flex-start
		.choose-item-text{
			max-width:115px;
			overflow: hidden;
			text-overflow:ellipsis;
			white-space: nowrap;
		}
	}
	.pro-row{
		position relative
		height:66px;
		padding: 0 10px;
		display: flex;
		align-items: center;
		flex-direction: row;
		background: #FFFFFF;
		margin-top: 10px;
		box-shadow: 1px 1px 6px 0px rgba(71, 71, 71, 0.2);
		border-radius: 4px;
		.pro-img{
			width: 40px;
			height: 40px;
			margin-right :10px;
		}
		.el-icon-remove	{
			cursor: pointer
			position: absolute;
			right: -9px;
			bottom: 55px
			font-size: 18px;
			font-weight: bold;
			color: var(--fx-primary-color);
		}
	}
	.advert-row{
		position relative
		height:114px;
		display: flex;
		align-items: center;
		flex-direction: row;
		background: #FFFFFF;
		margin-top: 10px;
		box-shadow: 1px 1px 6px 0px rgba(71, 71, 71, 0.2);
		border-radius: 4px;
		.el-icon-remove	{
			cursor: pointer
			position: absolute;
			right: -9px;
			bottom: 105px
			font-size: 18px;
			font-weight: bold;
			color: var(--fx-primary-color);
		}
	}
	.is-select-box{
		border: 1px solid var(--fx-primary-color) !important;
		color: var(--fx-primary-color) !important;
		background-color: var(--fx-primary-color) !important

	}
	.recommendation-1-box{
		display:flex;
		width:400px;
		height: 200px;
		flex-direction: row;
		.item-box{
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #CCCCCC;
			color: #CCCCCC;
		}
	}
	.recommendation-2-box{
		display:flex;
		width:400px;
		height: 133px;
		flex-direction: row;
		.item-box{
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border: 1px solid #CCCCCC;
			color: #CCCCCC;
		}
	}
	.recommendation-3-box{
		display:flex;
		width:400px;
		height: 400px;
		flex-direction: column;
		.item-box{
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border: 1px solid #CCCCCC;
			color: #CCCCCC;
		}
	}
	.recommendation-4-box{
		display:flex;
		width:400px;
		height: 266px;
		flex-direction: column;
		.item-box{
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border: 1px solid #CCCCCC;
			color: #CCCCCC;
		}
	}
	.recommendation-5-box{
		display:flex;
		width:400px;
		height: 300px;
		flex-direction: column;
		.item-box{
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border: 1px solid #CCCCCC;
			color: #CCCCCC;
		}
	}
	.recommendation-6-box{
		display:flex;
		width:400px;
		height: 400px;
		flex-direction: row;
		.item-box{
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border: 1px solid #CCCCCC;
			color: #CCCCCC;
		}
	}
	.el-dropdown-link {
		cursor: pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
	}
}
</style>
<style lang="stylus">
.componentbox {
	.radioClass {
		.el-radio__label{
			display:none
		}
	}
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
